<template>
  <div class="approvel-list">
    <div class="top-container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <div class="row">
          <el-form-item label="审批类型：" prop="approvalType">
            <el-select
              v-model="ruleForm.approvalType"
              placeholder="请选择"
              class="gray white"
              clearable
            >
              <el-option
                v-for="item in approvalTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批状态：" prop="approvalStatus">
            <el-select
              v-model="ruleForm.approvalStatus"
              placeholder="请选择"
              class="gray white"
              clearable
            >
              <el-option
                v-for="item in approvalList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资产：" prop="assets">
            <el-input class="gray white" placeholder="请输入资产名称、编号" v-model="ruleForm.assets" clearable></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button class="btn-gray" @click="resetForm('ruleForm')">重置</el-button>
            <el-button class="btn-blue" type="primary" @click="search">搜索</el-button>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="发起日期：" prop="launchDate">
            <el-date-picker
              v-model="ruleForm.launchDate"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="申请人：" prop="userName">
            <el-input class="gray white" placeholder="请输入" v-model="ruleForm.userName" clearable></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="approvel-container">
      <div class="approvel-title">
        <div class="title">审批记录列表</div>
        <div class="search">
          <el-button
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleDownloadApplicationProperty
              ) !== -1
            "
            type="text"
            class="btn-blue"
            @click="reportExcel"
            >记录导出</el-button
          >
        </div>
      </div>
      <div class="table" v-if="tableData.length > 0">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
            :show-overflow-tooltip="item.showOverflowTooltip"
          />
          <el-table-column
            label="审批状态"
            prop="approvalStatus"
            min-width="100"
          >
            <template slot-scope="scope">
              <div class="look-records">
                <div class="approvalStatus" v-if="scope.row.approvalStatus === 2">
                  <span>已同意</span>
                </div>
                <div class="approvalStatus approvalStatus2" v-if="scope.row.approvalStatus === 1">
                  <span>审批中</span>
                </div>
                <div class="approvalStatus approvalStatus3" v-if="scope.row.approvalStatus === 4">
                  <span>待审批</span>
                </div>
                <div class="approvalStatus approvalStatus4" v-if="scope.row.approvalStatus === 3">
                  <span>已驳回</span>
                </div>
                <div class="approvalStatus approvalStatus4" v-if="scope.row.approvalStatus === 5">
                  <span>已作废</span>
                </div>
                <i class="el-icon-view" @click="approval(scope.row)"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="接收人"
            prop="receiverName"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.receiverName != '/'"
                effect="dark"
                placement="top">
                <div slot="content">
                  <div>
                    接受状态：{{ scope.row.receiveResVal }}
                    <br />
                    接
                    <span style="margin: 0px 2.5px;">
                      受
                    </span>
                    人：{{ scope.row.receiverName }}
                    <br />
                  </div>
                </div>
                
                <div class="approvalStatus approvalStatus2" v-if="scope.row.receiveRes == 1">
                  <span>{{ scope.row.receiverName }}</span>
                </div>
                <div class="approvalStatus" v-if="scope.row.receiveRes == 2">
                  <span>{{ scope.row.receiverName }}</span>
                </div>
                <div class="approvalStatus approvalStatus4" v-if="scope.row.receiveRes == 3">
                  <span>{{ scope.row.receiverName }}</span>
                </div>
              </el-tooltip>
              <p v-else>{{ scope.row.receiverName }}</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="totalNum"
            :currentPage="currentPage"
            @queryChange="onQueryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div class="nothing" v-if="tableData.length == 0">
        <div>
          <div>
            <img src="../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>

    <!-- 当前审批记录 -->
    <el-dialog
      class="approvalRecordDialog"
      title="当前审批人"
      top="15vh"
      :visible.sync="approvalRecordDialog"
      width="420px"
    >
      <el-steps :active="steps" direction="vertical">
        <el-step v-for="(item,index) in stepList" :key="index" :class="{isRefuse: item.isRefuse}">
          <div slot="icon" class="stepsImg">
            <div v-if="item.isApprovel" class="steps-num">
              {{index+1}}
            </div>
            <img v-else class="steps-img" :src="steps == item.step ? item.highLightIcon : item.icon">
          </div>
          <div slot="title">
            <div class="title" :class="item.currentApprove == 1 ?(item.approvalRes == 2 ?'red-active':'blue-active'):''">
              <div>
                <span>{{ item.approverName }}</span>
                <span v-if="item.time">({{ item.time }})</span>
              </div>
              <span class="passStatus">{{ item.passStatus }}</span>
            </div>
            <div v-if="item.remarks" class="remark">备注：{{ item.remarks }}</div>
          </div>
        </el-step>
      </el-steps>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-blue" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import Assets from "@/models/assets.js"
import { operationMixins } from '@/common/mixins/operation/operation.js'
import { statusMixins } from '@/common/mixins/status/status.js'
import { formatTimeToDate } from "@/common/js/utils.js"
export default {
  mixins: [statusMixins, operationMixins],

  components: {
    PaginationTpl,
  },

  data() {
    return {
      ruleForm: {
        approvalType: '',
        approvalStatus: '',
        assets: '',
        launchDate: '',
        userName: '',
        place: '',
      },
      /* 资产状态 */
      approvalTypeList: [
        {
          id: 3,
          name: "申领"
        },
        {
          id: 4,
          name: "报废"
        },
        {
          id: 5,
          name: "移交"
        },
        {
          id: 6,
          name: "盘盈"
        },
        {
          id: 7,
          name: "盘亏"
        },
        {
          id: 8,
          name: "调拨"
        },
      ],
      /* 是否闲置 */
      approvalList: [
        { id: 1, name: '审批中'},
        { id: 2, name: '已同意'},
        { id: 3, name: '已驳回'},
        { id: 4, name: '待审批'},
        { id: 5, name: '已作废'}
      ],
      
      totalNum: 0,
      currentPage: 1,
      tableData: [],
      tableTitleList: [
        { label: '申请人', prop: 'applicantName', showOverflowTooltip: false, width: 100},
        { label: '所在部门', prop: 'deptName', showOverflowTooltip: false, width: 100},
        { label: '所属部门', prop: 'groupName', showOverflowTooltip: false, width: 100},
        { label: '审批类型', prop: 'typeVal', showOverflowTooltip: false, width: 100},
        { label: '发起日期', prop: 'createTime', showOverflowTooltip: false, width: 100},
        { label: '资产编号', prop: 'code', showOverflowTooltip: false, width: 100},
        { label: '资产名称', prop: 'propertyName', showOverflowTooltip: true, width: 200},
      ], 
      
      approvalRecordDialog: false,
      steps: 1,
      stepList: [],
      finishIcon: require('../../../../assets/fixed-assets/approval-finish.png'),
    }
  },

  created() {
    config()
    this.initApprovelRecordsList()
  },

  methods: {
    initApprovelRecordsList() {
      let currentPage = this.currentPage;
      let type = this.ruleForm.approvalType;
      let status = this.ruleForm.approvalStatus;
      let name = this.ruleForm.assets;
      let startTime
      let endTime
      if (this.ruleForm.launchDate[0]) {
        startTime = this.ruleForm.launchDate[0]
      } else {
        startTime = ''
      }
      if (this.ruleForm.launchDate[1]) {
        endTime = this.ruleForm.launchDate[1]
      } else {
        endTime = ''
      }
      let userName = this.ruleForm.userName;
      let data = {
        currentPage,
        type,
        status,
        name,
        startTime,
        endTime,
        userName,
      }
      Assets.getApprovalRecordList(data).then(res => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.applicantId = value.applicationId;
            obj.applicantName = value.userName;
            obj.approverName = value.currentUserName;
            obj.deptName = value.deptName;
            obj.code = value.code;
            obj.createTime = formatTimeToDate(value.createTime);
            obj.groupName = value.groupName;
            obj.propertyName = value.name;
            obj.currentUserId = value.currentUserId;
            obj.receiveRes = value.receiveRes;
            obj.receiverName = value.receiverName ? value.receiverName : '/';
            obj.type = value.type;
            obj.typeVal = this.FIXED_ASSETS_RECORD_STATUS[value.type];
            obj.receiveResVal = this.FIXED_ASSETS_RECORD_RECEVICE_STATUS[value.receiveRes];
            obj.approvalStatus = value.status;
            obj.approvalRecordList = value.approvalRecordList;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initApprovelRecordsList();
    },

    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initApprovelRecordsList();
    },
    
    /* 记录导出 */
    reportExcel() {
      let currentPage = this.currentPage;
      let type = this.ruleForm.approvalType;
      let status = this.ruleForm.approvalStatus;
      let name = this.ruleForm.assets;
      let startTime
      let endTime
      if (this.ruleForm.launchDate[0]) {
        startTime = this.ruleForm.launchDate[0]
      } else {
        startTime = ''
      }
      if (this.ruleForm.launchDate[1]) {
        endTime = this.ruleForm.launchDate[1]
      } else {
        endTime = ''
      }
      let userName = this.ruleForm.userName;
      let data = {
        currentPage,
        type,
        status,
        name,
        startTime,
        endTime,
        userName,
      }
      Assets.getDownloadApprovalRecord(data).then(res => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    
    /* 查看审批人记录 */
    approval(row) {
      this._getApprovalRecord(row)
      this.approvalRecordDialog = true
    },

    confirm() {
      this.approvalRecordDialog = false
    },

    _getApprovalRecord(row) {
      let num = 0
      let arr = []
      row.approvalRecordList.map((i,index) => {
        let obj = {}
        obj.approverName = i.approverName
        obj.approverId = i.approverId
        obj.approvalRes = i.approvalRes
        if (i.time) {
          obj.time = i.time
        } else {
          obj.time = ''
        }
        if (i.approvalRes) {
          obj.passStatus = this.FIXED_ASSETS_RECORD_PROCEDURE_STATUS[i.approvalRes]
        } else {
          obj.passStatus = ''
        }
        if (i.remark) {
          obj.remarks = i.remark
        } else {
          obj.remarks = ''
        }
        
        obj.isApprovel = false
        if (i.isCurrentUser) {
        // if (row.currentUserId == i.approverId) {
          obj.currentApprove = 1
          num = index
          obj.isApprovel = true
          this.steps = index+1
          if (i.approvalRes == 2) {
            obj.isRefuse = true
          } else if (i.approvalRes == 1) {
            obj.highLightIcon = this.finishIcon
            obj.isRefuse = false
          } else {
            obj.isRefuse = false
          }
        } else {
          if (num) {
            obj.isApprovel = true
          }
          obj.currentApprove = 0
          if (i.approvalRes == 1) {
            obj.icon = this.finishIcon
            obj.isRefuse = false
          } else {
            obj.isRefuse = false
          }
        }
        obj.step = index+1
        arr.push(obj)
      })
      this.stepList = arr
    }
  }
}
</script>

<style lang='scss'>
.approvel-list {
  flex: 1;
  width: 100%;
  background: $bg-WhiteSmoke;
  @include flex-column-start;
  .top-container {
    width: 100%;
    box-sizing: border-box;
    background: $bg-white;
    padding: 10px;
    .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      width: 25%;
      margin-bottom: 10px;
      .el-input__prefix, .el-input__suffix {
        top: -2px;
      }
    }
    .el-date-editor {
      width: 100%;
    }
    .row {
      @include flex-start;
      .btn {
        .el-form-item__content {
          margin-left: 20px!important;
          display: flex;
        }
      }
    }
  }
  .approvel-container {
    flex: 1;
    width: 100%;
    margin-top: 20px;
    padding: 8px 10px;
    background: $bg-white;
    box-sizing: border-box;
    position: relative;
    .approvel-title {
      @include flex-between;
      margin-bottom: 20px;
      .title {
        font-size: $fs-medium-s;
        color: $color-BlackGrey;
      }
      .search {
        display: flex;
        .add {
          margin-left: 12px;
          padding: 0;
        }
      }
    }
    .approverName {
      cursor: pointer;
      color: $color-DeepReddishBlue;
    }
    .look-records {
      @include flex-start;
      .el-icon-view {
        cursor: pointer;
        margin-left: 3px;
        color: $color-DeepReddishBlue;
      }
    }
    .approvalStatus {
      ::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        background: $bg-LawnGreen;
        border-radius: 50%;
        margin-right: 5px;
        margin-bottom: 1px;
      }
    }
    .approvalStatus2 {
      ::before {
        background: $bg-DeepReddishBlue;
      }
    }
    .approvalStatus3 {
      ::before {
        background: $bg-Gainsboro;
      }
    }
    .approvalStatus4 {
      ::before {
        background: $bg-Crimson;
      }
    }
    
    .nothing {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      img {
        width: 157px;
        height: 157px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
  }
  
  .el-dialog__body {
    .el-form {
      display: flex;
      justify-content: space-between;
      padding-bottom: 0px;
      .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before,
      .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
        display: none;
      }
      .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before,
      .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
        content: "*";
        color: $bg-Required;
        margin-left: 4px;
      }
      .el-form-item__label {
        width: 100%;
        line-height: 22px;
        text-align: left;
      }
    }
  }
    
  .dialog-footer {
    height: 70px;
    margin-right: 20px;
    @include flex-end;
  }

  .approvalRecordDialog {
    .el-dialog {
      min-height: 360px;
    }
    .el-dialog__body {
      min-height: 200px;
      padding: 20px;
    }
    .el-dialog__footer {
      padding: 0px;
      @include flex-end;
    }
    .dialog-footer {
      margin-right: 20px;
      padding: 0px;
    }
    .title {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .passStatus {
        margin-left: 50px;
      }
      div,
      span {
        line-height: 16px;
      }
    }
    .blue-active {
      color: $color-DeepReddishBlue;
    }
    .red-active {
      color: $color-PhoneStar;
    }
    .remark {
      width: 340px;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
    }
    .el-step__main {
      min-height: 24px;
    }
    .el-step__icon,
    .stepsImg,
    .steps-img {
      width: 16px;
      height: 16px;
    }
    .steps-num {
      line-height: 18px;
    }
    .el-step__head.is-process {
      color: $color-LightGrey;
      border-color: $color-LightGrey;
    }
    .isRefuse {
      .el-step__head {
        .el-step__icon {
          border-color: $bg-Crimson;
          background: $bg-Crimson;
          color: $color-white;
        }
      }
      .el-step__main {
        .el-step__title {
          .title {
            color: $color-Crimson;
          }
        }
      }
    }
  }
}
</style>
